import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './right-side-alert-not-current-lot.vue';
import { LiveData } from '../../views/live/index';

import jQuery from 'jquery';

// Websockets
import { WebsocketsListener } from '../../utils/ws';

@Component({
    mixins: [template],
})
export default class RightSideAlertNotCurrentLot extends Vue {
    @Prop(Object) readonly auctionData!: LiveData;
    @Prop(Object) readonly wsListener!: WebsocketsListener;

    constructor() {
        super();

        this.wsListener.onPost(
            'live.reintroduction',
            (success: boolean, data: any) => {
                if (!success) {
                    alert(
                        'Cererea de reintroducere nu a fost trimisa. Eroare: ' +
                            String(data),
                    );
                    return;
                }

                alert(
                    'Cererea de reintroducere a fost trimisa cu succes. Vei fi notificat daca aceasta va fi acceptata',
                );
            },
        );
    }

    requestLotReintroduction(lot: any) {
        if (
            !this.auctionData ||
            typeof this.auctionData.auctionUserStatus !== 'number'
        ) {
            alert('Eroare. Te rugam sa dai refresh paginii curente');
        }

        if (this.auctionData.auctionUserStatus == 0) {
            return alert(
                'Trebuie sa te autentifici pentru a reintroduce un lot',
            );
        } else if (this.auctionData.auctionUserStatus == 1) {
            return alert(
                'Trebuie sa ai un cont verificat pentru a reintroduce un lot',
            );
        } else if (this.auctionData.auctionUserStatus == 2) {
            return alert(
                'Trebuie sa te inscrii la licitatie pentru a reintroduce un lot',
            );
        }

        if (
            confirm(
                'Cand ceri reintroducerea unui lot, automat vei licita pretul de pornire!',
            )
        ) {
            this.wsListener.sendPost('live.reintroduction', {
                auction: this.auctionData.auction._id,
                lot: lot._id,
            });
        }
    }

    goToLiveSlot() {
        this.$store.state.currentShownLot = this.auctionData.activeLot;

        let currentItemInCarouselOffsetLet: number =
                this.auctionData.activeLot * 98,
            carouselWidth: any = jQuery(
                '.right-side-lots-list__items .owl-stage-outer',
            ).outerWidth(),
            allItemsWidth: any = jQuery(
                '.right-side-lots-list__items .owl-stage',
            ).outerWidth();

        if (carouselWidth < allItemsWidth) {
            jQuery('.right-side-lots-list__items .owl-stage').css(
                'transform',
                'translate3d(-' +
                    currentItemInCarouselOffsetLet +
                    'px, 0px, 0px)',
            );
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/right-side-alert-not-current-lot/index.ts